module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.isScheduled) ? _c('p', {
    staticClass: "view__title--sub"
  }, [_vm._v(_vm._s(_vm.L.localize("Campaign_ScheduledAt")) + " " + _vm._s(_vm.campaign.scheduledAt))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [(!_vm.isScheduled) ? _c('Btn', {
    attrs: {
      "isLoading": _vm.loadingSend,
      "float": "right",
      "label": "Campaigns_SendNow"
    },
    on: {
      "click": _vm.triggerSend
    }
  }) : _vm._e(), _vm._v(" "), _c('Btn', {
    attrs: {
      "isLoading": _vm.loadingSendTest,
      "label": "Campaigns_SendTest"
    },
    on: {
      "click": _vm.triggerSendTestModal
    }
  })], 1), _vm._v(" "), _c('article', {
    staticClass: "preview"
  }, [_c('div', {
    staticClass: "preview__content",
    domProps: {
      "innerHTML": _vm._s(_vm.campaign.body)
    }
  })]), _vm._v(" "), _c('sweet-modal', {
    ref: "sendTestModal",
    attrs: {
      "title": _vm.L.localize('Campaigns_Breadcrumb_SendTest')
    }
  }, [_c('TextBox', {
    attrs: {
      "label": "Label_EmailAddressesWithComma",
      "validate": _vm.$v.model,
      "modelPath": "emails",
      "acc": "emails"
    },
    on: {
      "input": _vm.$v.model.emails.$touch
    },
    model: {
      value: (_vm.model.emails),
      callback: function($$v) {
        _vm.$set(_vm.model, "emails", $$v)
      },
      expression: "model.emails"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Send"
    },
    on: {
      "click": _vm.sendTest
    }
  })], 1), _vm._v(" "), _c('sweet-modal', {
    ref: "scheduleModal",
    attrs: {
      "title": _vm.L.localize('Campaign_Schedule_Modal_Title')
    }
  }, [_c('TextBox', {
    attrs: {
      "label": "Label_ScheduleAt",
      "validate": _vm.$v.scheduling,
      "modelPath": "date",
      "acc": "scheduledAt",
      "type": "datetime"
    },
    on: {
      "input": _vm.$v.scheduling.date.$touch
    },
    model: {
      value: (_vm.scheduling.date),
      callback: function($$v) {
        _vm.$set(_vm.scheduling, "date", $$v)
      },
      expression: "scheduling.date"
    }
  }), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Campaigns_Schedule"
    },
    on: {
      "click": _vm.schedule
    }
  })], 1), _vm._v(" "), _c('sweet-modal', {
    ref: "sendNowModal",
    attrs: {
      "title": _vm.L.localize('Campaigns_Breadcrumb_Send_Confirm_Title')
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.L.localize("Campaigns_Breadcrumb_Send_Confirm_Message")))]), _vm._v(" "), _c('Btn', {
    attrs: {
      "label": "Campaigns_SendNow"
    },
    on: {
      "click": _vm.send
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3aba1e5c!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/views/campaigns/form/CampaignPreview.vue
// module id = 726
// module chunks = 1